import GMLFormat from './gml_format';
const VERSION_GML3 = 1001;

import { POINT,
	LINESTRING,
	POLYGON,
	MULTI_POINT,
	MULTI_LINESTRING,
	MULTI_POLYGON
} from '../geometry_type';


class GML311 extends GMLFormat {

	constructor() {
		super(VERSION_GML3, "http://www.opengis.net/gml", "featureMember");
		this.addGeometryType("Point", POINT);
		this.addGeometryType("Polygon", POLYGON);
		this.addGeometryType("LineString", LINESTRING);
		this.addGeometryType("MultiPoint", MULTI_POINT);
		this.addGeometryType("MultiSurface", MULTI_POLYGON);
		//addGeometryType("LineString", LINESTRING);
	}
	
}

export default GML311;